import { ArrayLikeStackItem } from './ArrayLikeStackItem';
import { getNextID } from './referenceCounter';
import { StackItemType } from './StackItemType';
export class ArrayStackItem extends ArrayLikeStackItem {
    constructor() {
        super(...arguments);
        this.referenceID = getNextID();
    }
    toStructuralKey() {
        return `${this.referenceID}`;
    }
    equals(other) {
        return this === other;
    }
}
ArrayStackItem.type = StackItemType.Array;

//# sourceMappingURL=ArrayStackItem.js.map
